import { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

import EaglesMade from './components/eagles-made';
import MoneyDonated from './components/money-donated';

const supers = {
  INIT: 0,
  EAGLES_MADE: 10,
  MONEY_DONATED: 20
};

const EagleTracker = (prop) => {
  const { 
    eagleCount, 
    prevEagleCount, 
    canPlay = false, 
    takeoverMode = true, 
    orientation = 'landscape', 
    setIsLoading = () => {},
    setIsPlaying = () => {}
  } = prop;
  const playerRef = useRef(null);
  const [ isReveal, setReveal ] = useState(false);
  const [ isPlaying, setPlaying ] = useState(false);
  const [ superToShow, setSuperToShow ] = useState(supers.INIT);
  const [ zeroTimeStamp, setZeroTimeStamp ] = useState(0);

  const videoSource = 
    `https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/${takeoverMode === true ? 'eagle_made' : 'eagle_count'}${orientation == 'portrait' ? '_v' : ''}.mp4`;

  useEffect(() =>{
    if (canPlay && eagleCount > prevEagleCount) {
      playAnimation();
    }
  }, [ eagleCount, prevEagleCount ]);

  useEffect(() => {
    if (canPlay) {
      playAnimation();
    }
  }, [ canPlay ])

  const playAnimation = () => {
    if (!isReveal && !isPlaying) {
      playerRef.current.currentTime = 0;
      setPlaying(true);
      setReveal(true);
      /*setTimeout(() => {
        setReveal(true);
        setTimeout(() => {
          setPlaying(false);
          setReveal(false);
        }, 38000); // Match animation duration
      }, 200);*/
    }
  };

  const handleVideoPlaying = (event) => {
    setZeroTimeStamp(event.timeStamp);
  };

  const handleVideoProgress = (event) => {
    if (event.timeStamp >= zeroTimeStamp + 10500 && event.timeStamp <= zeroTimeStamp + 14000) {
      console.info(`Showing Eagles Made @ ${event.timeStamp - zeroTimeStamp}`);
      setSuperToShow(supers.EAGLES_MADE);
    }
    else if (event.timeStamp >= zeroTimeStamp + 15700 && event.timeStamp <= zeroTimeStamp + 19200) {
      console.info(`Showing Money Donated @ ${event.timeStamp - zeroTimeStamp}`);
      setSuperToShow(supers.MONEY_DONATED);
    }
    else {
      setSuperToShow(supers.INIT);
    }
  };

  const handleRevealEnd = () => {
    if (!isReveal) {
      console.log('Resetting eagle tracker video to start');
      playerRef.current.currentTime = 0;
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ ...styles.overlay, ...(isReveal ? styles.reveal : {}) }} onTransitionEnd={handleRevealEnd}></div>
      <div style={styles.video}>
        <ReactPlayer
          ref={playerRef}
          src={videoSource}
          height='100%'
          width='100%'
          muted={true}
          playing={isPlaying}
          loop={false}
          onPlaying={handleVideoPlaying}
          onTimeUpdate={handleVideoProgress}
          onReady={() => setIsLoading(false)}
          onEnded={() => { setPlaying(false); setReveal(false); setIsPlaying(false) }}
        />
      </div>
      <EaglesMade count={eagleCount} orientation={orientation} show={superToShow === supers.EAGLES_MADE} />
      <MoneyDonated count={eagleCount} orientation={orientation} show={superToShow === supers.MONEY_DONATED} />
    </div>
  );
};

const variables = {
  '--canvas-height': '100%',
  '--canvas-width': '100%',
  '--font-size': '4.2vw',
};

const blue = '#003061';

const styles = {
  container: { ...variables, ...{
    background: '#d0d0d0',
    fontSize: 'calc(var(--font-size)',
    //height: 'calc(var(--canvas-height))',
    //width: 'calc(var(--canvas-width))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    overflow: 'hidden'
  }},

  overlay: {
    background: '#000000',
    height: '100vh',
    width: '100vw',
    opacity: '1',
    position: 'absolute',
    transition: 'opacity 1s'
  },

  reveal: {
    opacity: '0'
  },

  video: {
    height: '100%',
    width: '100%',
    minHeight: '1080px'
  }
};

export default EagleTracker;